import { createContext } from 'react';
var consentDetailsV1 = {
  consentList: [{
    accepted: false,
    agreementMasterId: '',
    agreementTypeId: '',
    documentName: '',
    userAgreementId: null,
    userId: '',
    version: ''
  }]
};
var defaultState = {
  consentDataV1: consentDetailsV1.consentList,
  setConsentDetailsV1FromInput: function setConsentDetailsV1FromInput(consentData) {
    return consentData;
  }
};
var ConsentDetailsContextV1 = /*#__PURE__*/createContext(defaultState);
export { ConsentDetailsContextV1, consentDetailsV1 };